module.exports = __webpack_public_path__ + "static/media/Icon_info.5989e345.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/Icon_info.svg
// module id = 1732
// module chunks = 0